export default __webpack_public_path__ + "f0a30981087e15fd0d76700eebce56ba.svg";